/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface OrganizationsCounters { 
    total_organizations_count: number;
    foundation_organizations_count: number;
    institute_organizations_count: number;
    hospital_organizations_count: number;
    research_organizations_count: number;
}